import React from "react";

function Specializes() {
  return (
    <>
      <div>
        <div className="container p-5">
          <div
            className="pricing-style-one-item-cos bg-dark text-light"
            style={{
              backgroundImage:
                "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
            }}
          >
            <div className="text-center">
              <h3>Ethereum Wallet Development Service</h3>
              <div className="bottom">
                <div className="pricing">
                  <p>
                    Xeer Technology specializes in creating secure,
                    user-friendly wallets that facilitate seamless transactions
                    and management of Ethereum-based assets. Our solutions
                    incorporate advanced security features and a scalable
                    architecture, ensuring a reliable experience for both novice
                    and experienced users. Whether you’re launching a new
                    platform or enhancing your existing services, trust us to
                    deliver a future-proof wallet that meets your unique needs.
                  </p>
                </div>
                <a className="btn btn-style-one mt-30" href="#">
                  Get Started
                </a>
              </div>
            </div>
            {/* <div className="right-info"></div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Specializes;
